export const KBEditorNavButton = () => {
  return null;
};
